module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-auto-template/src/templates/footer.html -->\n<div class="inner">\n  <nav\n    role="navigation"\n    id="footer-page-menu"\n    class="nx-action-context navbar"\n    data-action-context="headerMenu"\n    data-nx-template="menuView-headerActions"\n  ></nav>\n  <span class="footer-copyright pull-left primary-color"\n  >'+
((__t=( Netx.cms.portal.attributes.copyright ))==null?'':__t)+
'</span\n  >\n</div>\n';
}
return __p;
};
